import { useState, useContext } from 'react';
import { Form } from 'react-bootstrap';
import axios from 'axios';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPowerOff } from '@fortawesome/free-solid-svg-icons'
import { GlobalContext } from '../../../store/GlobalState';
import { apiUrl } from '../../../utilities/requestHelpers';
import { createToast } from '../../../utilities/toastHelpers';
import './Login.css';
import Spinner from 'react-bootstrap/Spinner';
import { getCookieValue } from '../../../utilities/cookieHelpers';
import telkoreLogo from '../../Icons/telkore-logo.png';


const Login = () => {
  const { jwtToken, assignJwtToken, toggleToasts } = useContext(GlobalContext);

  const [userName, setUserName] = useState('');
  const [pass, setPass] = useState('');
  const [isForgetPassword, setIsForgetPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const user = {
      username: userName,
      password: pass,
    };

    try {
      const result = await axios.post(
        `${apiUrl}/authentication/login`,
        user,
      );
  
      if (result.status === 200) {
        const data = await result.data;
        assignJwtToken(data.token, data.group);
        toggleToasts(createToast('success', 'Successfully logged in!'));
      }
    } catch (err) {
      toggleToasts(createToast('danger', 'Failed to log in.'));
    }
  };
  //handle reset password form submit
  const handleResetPassword = async (e) => {
    setLoading(true);
    e.preventDefault();

    if (!email) {
      createToast('danger', 'Please enter your email address');
      return;
    }

    const data = 
    { 
      Email: email,
     };

    try {
      const result = await axios.post(`${apiUrl}/authentication/sent-reset-password`, null, {
        params: { email },
      });
      debugger
      if (result.status === 200) {
          setLoading(false);
          toggleToasts(createToast('success', 'Password reset link sent! Please check your email.'));
          setIsForgetPassword(false); // Hide the email input after successful request
      }
    } catch (err) {
      setLoading(false);
      toggleToasts(createToast('danger', 'Failed to send password reset link.'));
    }try{
      const result = await axios.post(`${apiUrl}/authentication/sent-reset-password-for-user-manager`, null, {
      params: { email },
      });
    } catch (err) {
    createToast('danger', 'Failed to send password reset link.');
  }
  };
  if ((jwtToken === false || jwtToken === null || jwtToken === '') && getCookieValue('telkoresched_token') === '') {
    return (
      <div className="form-page">
        <div className="form-container">
          {/* 🔹 Logo Section */}
          <div className="form-logo">
            <img 
              src={telkoreLogo}
              alt="App Logo" 
              className="login-logo"
            />
          </div>
          {!isForgetPassword ? (
            // Login Form
            <Form onSubmit={(e) => handleFormSubmit(e)}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Enter User Name"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                />
              </Form.Group>
             <div className="forget-password-link">
             <a
              onClick={() => setIsForgetPassword(true)}
              role="button"
              tabIndex={0} // Allows it to be focusable
              onKeyDown={(e) => e.key === 'Enter' && setIsForgetPassword(true)}
            >
              Forgot Password?
            </a>
             </div>
              <button className="login-button" type="submit">
                Login
              </button>
             
            </Form>
          ) : (
            // Reset Password Form (showing email input)
            <Form onSubmit={(e) => handleResetPassword(e)}>
              <Form.Group className="mb-3">
                <Form.Control
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>

              <button className="login-button" type="submit">
                {/* <FontAwesomeIcon icon={faPowerOff} /> */}
                {/* <FontAwesomeIcon icon="fa-solid fa-power-off" /> */}
                Send
              </button>
              <button
                type="submit"
                className="btn btn-secondary"
                onClick={() => window.location.href = '/'}
              >
                Back
              </button>
            </Form>
          )}
          { loading && (
            <Spinner animation="border" className="spinner-class" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </div>
      </div>
    );
  } else {
    return null; // If logged in, return null (don't show login form)
  }
};

export default Login;
